@if (!exportMode) {
<div class="career__edit-button-div">
  @if (editMode) {
    <button
      class="career__edit-btn career__edit-btn--text"
      mat-raised-button
      (click)="onCancelEdit()"
    >
      {{ 'general.cancel' | translate }}
    </button>

    <button
      mat-icon-button
      class="career__edit-btn career__edit-btn--icon"
      (click)="onCancelEdit()"
      [attr.aria-label]="'general.cancel' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
  <button
    mat-flat-button
    class="career__edit-btn career__edit-btn--text"
    [disabled]="editMode && (!formChanged || form.invalid || isSaving)"
    (click)="onToggleEdit()"
  >
    {{ editMode ? ('general.save' | translate) : ('general.edit' | translate) }}
  </button>

  <button
    mat-icon-button
    class="career__edit-btn career__edit-btn--icon"
    [disabled]="editMode && (!formChanged || form.invalid || isSaving)"
    (click)="onToggleEdit()"
    [attr.aria-label]="(editMode ? ('general.save' | translate) : ('general.edit' | translate))"
  >
    <mat-icon>{{ editMode ? 'save' : 'edit' }}</mat-icon>
  </button>
</div>
}

<form [formGroup]="form">
  @if (werdegangArray?.length > 0) {
    <div formArrayName="werdegang" class="career__wrapper">
      @for (group of werdegangArray.controls; track group; let idx = $index) {
        <mat-card class="career__card" [class.career__card--export]="exportMode && !twoPagerMode">
          @if (exportMode && !twoPagerMode) {
            <mat-checkbox
              [checked]="selectedExportIds.includes(group.value.uuid || idx.toString())"
              (change)="toggleExportSelection(group.value.uuid || idx.toString(), $event.checked)"
            ></mat-checkbox>
          }
          <div [formGroupName]="idx" class="career__content">
            <div class="career__field">
              @if (!editMode) {
                <div class="career__label-row">
                  <mat-label class="career__question">{{ 'career.beginning' | translate }}</mat-label>
                  <app-field-warning [finding]="entryFinding(idx, 'beginn')"></app-field-warning>
                </div>
                <p class="career__answer">{{ group?.value?.beginn | date: "MM/yyyy" }}</p>
              } @else {
                <mat-form-field>
                  <mat-label class="career__question">{{ 'career.beginning' | translate }}</mat-label>
                  <input required matInput [matDatepicker]='datepicker' formControlName="beginn"/>
                  <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
                  <mat-datepicker #datepicker>
                    <mat-datepicker-actions>
                      <button mat-button matDatepickerCancel>{{ 'general.cancel' | translate }}</button>
                      <button mat-flat-button matDatepickerApply>{{ 'general.apply' | translate }}</button>
                    </mat-datepicker-actions>
                  </mat-datepicker>
                  @if (group.get("beginn")?.invalid) {
                    <mat-error>{{ 'general.errors.required' | translate }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>

            <div class="career__field">
              @if (!editMode) {
                <div class="career__label-row">
                  <mat-label class="career__question">{{ 'career.company' | translate }}</mat-label>
                  <app-field-warning [finding]="entryFinding(idx, 'unternehmen')"></app-field-warning>
                </div>
                <p class="career__answer">{{ group?.value?.unternehmen }}</p>
              } @else {
                <mat-form-field>
                  <mat-label class="career__question">{{ 'career.company' | translate }}</mat-label>
                  <input required matInput type="text" formControlName="unternehmen" [maxlength]="LIMITS.SHORT_LABEL"/>
                  <mat-hint align="end">{{ (group.get('unternehmen')?.value?.length || 0) }}/{{ LIMITS.SHORT_LABEL }}</mat-hint>
                  @if (group.get("unternehmen")?.hasError('required')) {
                    <mat-error>{{ 'general.errors.required' | translate }}</mat-error>
                  }
                  @if (group.get("unternehmen")?.hasError('maxlength')) {
                    <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.SHORT_LABEL } }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>

            <div class="career__field">
              @if (!editMode) {
                <div class="career__label-row">
                  <mat-label class="career__question">{{ 'career.jobTitle' | translate }}</mat-label>
                  <app-field-warning [finding]="entryFinding(idx, 'stellenbezeichnung')"></app-field-warning>
                </div>
                <p class="career__answer">{{ group?.value?.stellenbezeichnung }}</p>
              } @else {
                <mat-form-field>
                  <mat-label class="career__question">{{ 'career.jobTitle' | translate }}</mat-label>
                  <input required matInput type="text" formControlName="stellenbezeichnung"
                         [maxlength]="LIMITS.JOB_TITLE"
                         (keypress)="onKeyPress($event)"/>
                  <mat-hint align="end">{{ (group.get('stellenbezeichnung')?.value?.length || 0) }}/{{ LIMITS.JOB_TITLE }}</mat-hint>
                  @if (group.get("stellenbezeichnung")?.hasError('required')) {
                    <mat-error>{{ 'general.errors.required' | translate }}</mat-error>
                  }
                  @if (group.get("stellenbezeichnung")?.hasError('maxlength')) {
                    <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.JOB_TITLE } }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>

            <div class="career__field">
              @if (!editMode) {
                <mat-label class="career__question">{{ 'career.end' | translate }}</mat-label>
                @if (group?.value?.ende) {
                  <p class="career__answer">{{ group.value.ende | date: "MM/yyyy" }}</p>
                } @else {
                  <p class="career__answer">{{ 'career.today' | translate }}</p>
                }
              } @else {
                @if (!group.get('stillWorking')?.value) {
                  <mat-form-field>
                    <mat-label class="career__question">{{ 'career.end' | translate }}</mat-label>
                    <input required matInput [matDatepicker]='picker' formControlName="ende"/>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker>
                      <mat-datepicker-actions>
                        <button mat-button matDatepickerCancel>{{ 'general.cancel' | translate }}</button>
                        <button mat-flat-button matDatepickerApply>{{ 'general.apply' | translate }}</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                }
                <mat-checkbox
                  class="career__check-still-working"
                  [disableRipple]="true"
                  formControlName="stillWorking"
                >
                  {{ 'education.untilToday' | translate }}
                </mat-checkbox>
              }
            </div>

            <div class="career__field">
              @if (!editMode) {
                <div class="career__label-row">
                  <mat-label class="career__question">{{ 'career.location' | translate }}</mat-label>
                  <app-field-warning [finding]="entryFinding(idx, 'ort')"></app-field-warning>
                </div>
                <p class="career__answer">{{ group?.value?.ort }}</p>
              } @else {
                <mat-form-field>
                  <mat-label class="career__question">{{ 'career.location' | translate }}</mat-label>
                  <input required matInput type="text" formControlName="ort" [maxlength]="LIMITS.LOCATION" (keypress)="onKeyPress($event)"/>
                  <mat-hint align="end">{{ (group.get('ort')?.value?.length || 0) }}/{{ LIMITS.LOCATION }}</mat-hint>
                  @if (group.get("ort")?.hasError('required')) {
                    <mat-error>{{ 'general.errors.required' | translate }}</mat-error>
                  }
                  @if (group.get("ort")?.hasError('maxlength')) {
                    <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.LOCATION } }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>

            <div class="career__field" [class.field-hint-anchor]="editMode">
              @if (!editMode) {
                <div class="career__label-row">
                  <mat-label class="career__question">{{ 'career.activity' | translate }}</mat-label>
                  <app-field-hint [text]="'tooltip.careerActivity' | translate" align="start"></app-field-hint>
                  <app-field-warning [finding]="entryFinding(idx, 'taetigkeit')"></app-field-warning>
                </div>
                <p class="career__answer">{{ group?.value?.taetigkeit }}</p>
              } @else {
                <span class="field-hint-corner">
                  <app-field-hint [text]="'tooltip.careerActivity' | translate"></app-field-hint>
                </span>
                <div class="career__field-row">
                  <mat-form-field>
                    <mat-label class="career__question">{{ 'career.activity' | translate }}</mat-label>
                    <input required matInput type="text" formControlName="taetigkeit" [maxlength]="LIMITS.FREETEXT"/>
                    <mat-hint align="end">{{ (group.get("taetigkeit")?.value?.length || 0) }}/{{ LIMITS.FREETEXT }}</mat-hint>
                    @if (group.get("taetigkeit")?.hasError('required')) {
                      <mat-error>{{ 'general.errors.required' | translate }}</mat-error>
                    }
                    @if (group.get("taetigkeit")?.hasError('maxlength')) {
                      <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.FREETEXT } }}</mat-error>
                    }
                  </mat-form-field>
                </div>
              }
            </div>

            @if (editMode) {
              <div class="career__save-button-div">
                <button
                  mat-mini-fab
                  color="primary"
                  (click)="openDeleteModal(idx)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
          </div>
        </mat-card>
      }
    </div>

    @if (editMode) {
      <div class="career__add-button">
        <button mat-flat-button type="button" (click)="addCareerForm()">
          <mat-icon>add</mat-icon>
          {{ 'career.button.createNewCareer' | translate }}
        </button>
      </div>
    }
  } @else {
    <mat-card appearance="outlined" class="career__no-data">
      <mat-card-content>
        {{ 'career.noCareer' | translate }}
        <p class="career__empty-hint">{{ 'career.emptyRequired' | translate }}</p>
      </mat-card-content>
    </mat-card>
  }
</form>

<!-- NP20-822: Bei vielen Einträgen ist der Weg nach oben weit; Abbrechen und Speichern
     kleben beim Bearbeiten am unteren Rand und rasten am Ende des Abschnitts ein. -->
@if (editMode && !exportMode) {
  <div class="sticky-save" role="group" [attr.aria-label]="'general.sectionActionsEnd' | translate">
    <button mat-stroked-button type="button" (click)="onCancelEdit()">
      {{ 'general.cancel' | translate }}
    </button>
    <button mat-flat-button type="button" [disabled]="!formChanged || form.invalid || isSaving" (click)="onToggleEdit()">
      {{ 'general.save' | translate }}
    </button>
  </div>
}

<app-modal
  modalId="deleteCareer"
  [title]="'career.modal.title'"
  [text]="'career.modal.text'"
  [(visible)]="showModal"
  [showButtons]="true"
  (save)="delete(currentIdx)"
  [showClose]="true"
  [saveText]="'general.delete'"
></app-modal>
